import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const loginApi = {
    async getPublickey() {
        return axios.get(`/core/public-key`);
    },
    async getKeyInfo() {
        return axios.get(`/key-info`);
    },
    async login(data: Pat) {
        return axios.post(`/login`, data);
    },
    async logOut() {
        return axios.post(`/logout`);
    },
    async forgotPassword(data: Pat) {
        return axios.post(`/email-captcha/send`, data);
    },
    async resetPassword(data: Pat) {
        return axios.post(`reset-pwd`, data);
    },
    async verifyCode(data: Pat) {
        return axios.post(`/email-captcha/verify`, data);
    },
};

export default loginApi;
